var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swoosh",style:(_vm.backgroundStyle())},[_c('div',{staticClass:"swoosh-text-container"},[_c('p',{staticClass:"swoosh-text"},[_vm._v(_vm._s(_vm.swooshText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }